export const GA_ID = "G-PG0V3CYC56";

export function pageview(url) {
  if (!window.gtag) return;

  window.gtag("event", "page_view", {
    send_to: GA_ID,
    page_location: window.location.href,
    page_path: url,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!window.gtag) return;

  window.gtag("event", name, {
    send_to: GA_ID,
    ...params,
  });
}
